export function asNumber(value) {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
}
export const clamp = (num, min, max) => {
    return Math.min(Math.max(num, min), max);
};
